import React from "react";
import TotemSkeleton from "../../components/TotemSkeleton/TotemSkeleton";
import TotemButton from "../../components/TotemButton/TotemButton";
import TotemOption from "../../components/TotemOption/TotemOption";
import { useUnit } from "effector-react";
import { LaundryOptionsContainer, TotalValue } from "./LaundryPaymentStyles";
import { toast } from "react-toastify";
import { PaymentOption } from "../../../../types/washing.types";
import { LaundryStore, setPage, setSelectedPayment } from "../../../../stores/LaundryStore/LaundryStore";
import { PAGES } from "../../../../stores/LaundryStore/LaundryStore.types";
import { paymentOptions } from "../../../../stores/LaundryStore/LaundryStore.consts";

const LaundryPayment: React.FC = () => {
  const { selectedPayment, finalPrice } = useUnit(LaundryStore);

  const handleGoBack = () => {
    setPage(PAGES.CHOOSE_LAUNDRY_MACHINE);
  };
  const handleConfirmPayment = () => {
    if (!selectedPayment?.type) {
      toast.error("Selecione uma forma de pagamento!");
      return false;
    }
    setPage(PAGES.LAUNDRY_PAYMENT_LOADING);
  };

  const renderOptions = () =>
    paymentOptions.map((option: PaymentOption) => {
      const isselected = selectedPayment?.type === option.type;

      return (
        <TotemOption
          title={option.title}
          isselected={isselected}
          execSelection={() => setSelectedPayment(option)}
        />
      );
    });

  const Buttons = (
    <>
      <TotemButton negative onClick={() => handleGoBack()} text="Voltar" />
      <TotemButton
        onClick={() => handleConfirmPayment()}
        disabled={!selectedPayment?.type}
        text="Realizar Pagamento"
      />
    </>
  );

  const renderPrice = () => (
    <TotalValue>
      <p>Total</p>
      <p>R$ {finalPrice.toFixed(2)}</p>
    </TotalValue>
  );

  return (
    <TotemSkeleton title="Forma de Pagamento" buttons={Buttons}>
      <LaundryOptionsContainer>{renderOptions()}</LaundryOptionsContainer>
      {renderPrice()}
    </TotemSkeleton>
  );
};

export default LaundryPayment;
